import * as PIXI from "pixi.js";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { SlingoLang } from "../lang/SlingoLang";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractScatterWinProperties.ts
 */
export class AbstractScatterWinProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.counterTimes = [
            5,
            0,
            3,
            6,
            9
        ];
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.animationProperties.equals(other.animationProperties) &&
            this.counterProperties.equals(other.counterProperties) &&
            this.title0Properties.equals(other.title0Properties) &&
            this.title1Properties.equals(other.title1Properties) &&
            this.size.equals(other.size);
    }
    setDefaultValues() {
        this.animationProperties = new SpineProperties(null, SlingoStyle.MODULE, new PIXI.Point(300, 300));
        this.title0Properties = new TextFieldProperties(FontStyle.DEFAULT, null, SlingoLang.SCATTER_0, ControlConstants.CENTER, ControlConstants.CENTER);
        this.title1Properties = new TextFieldProperties(FontStyle.DEFAULT, null, SlingoLang.SCATTER_1, ControlConstants.CENTER, ControlConstants.CENTER);
        this.counterProperties = new TextFieldProperties(FontStyle.DEFAULT, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.title0Properties.size = new PIXI.Point(1200, 300);
        this.title1Properties.size = new PIXI.Point(1200, 300);
        this.counterProperties.size = new PIXI.Point(1200, 200);
        this.size = new PIXI.Point(2436, 1280);
    }
}
//# sourceMappingURL=AbstractScatterWinProperties.js.map